const dateOrNull = (date: any): Date | null => {
	if (!date) return null;
	if (date instanceof Date) return date;
	if (date.toDate) return date.toDate();
	return new Date(date);
}

export { dateOrNull };